import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import Box from 'components/Box';
import { useDefaultFormFieldLayout } from './DefaultFormFieldLayout';
/**
 * This component aligns arbitrary content with their surrounding
 * form controls – this is especially useful when using the horizontal
 * field layout.
 *
 * It accepts all layout props starting with `horizontal…`, but will
 * also inherit the settings defined in `DefaultFormFieldLayout`
 */

export function FormFieldAlignedContent(_ref) {
  var children = _ref.children,
    layoutProps = _objectWithoutProperties(_ref, _excluded);
  var _useDefaultFormFieldL = useDefaultFormFieldLayout(layoutProps),
    horizontal = _useDefaultFormFieldL.horizontal,
    horizontalBreakpoint = _useDefaultFormFieldL.horizontalBreakpoint,
    horizontalLabelWidth = _useDefaultFormFieldL.horizontalLabelWidth;
  if (!horizontal) {
    return /*#__PURE__*/React.createElement("div", null, children);
  }
  return /*#__PURE__*/React.createElement(Box, {
    pl: [0, horizontalLabelWidth || 0],
    breakpoints: horizontalBreakpoint
  }, children);
}